import React, { useContext } from 'react';
import { pick, prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { getURLParam } from 'js/utils/url.util';
import { WebContent } from 'js/components/system/WebContent';
import { DefaultMenu } from 'js/components/main/DefaultMenu';
import { componentService } from 'js/services/component.service';
import { AppContext } from 'js/components/system/App/store/context';
import { useDeviceSelector, usePageSelector, useAppSelector } from 'js/store/hooks';

export const Menu = () => {
    const { addLoadingPromise } = useContext(AppContext);
    const location = useLocation();
    const { menuWcId, overrideMenu } = usePageSelector(pick(['menuWcId', 'overrideMenu']));
    const menuWCID = useAppSelector(prop('menuWCID'));
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const hideHeaderByUrl = getURLParam(location.search, 'hideHeader') === '1';
    const hideDesktopHeaderByUrl = getURLParam(location.search, 'showHeaderOnlyOnMobile') === '1';

    if (hideHeaderByUrl) {
        return null;
    }

    if (hideDesktopHeaderByUrl && isDesktop) {
        return null;
    }

    if (overrideMenu && !menuWcId) {
        return null;
    }

    if (overrideMenu && menuWcId) {
        return (
            isDesktop
                ? <WebContent id={menuWcId} addLoadingPromise={addLoadingPromise} />
                : <DefaultMenu slideMenuWcId={menuWcId} />
        );
    }

    if (menuWCID) {
        return (
            isDesktop
                ? <WebContent id={menuWCID} addLoadingPromise={addLoadingPromise} />
                : <DefaultMenu slideMenuWcId={menuWCID} />
        );
    }

    return <DefaultMenu />;
};

componentService.registerWebContentComponents({ Menu });
